<template>
  <v-app-bar-nav-icon
    :v-show="showButton"
    @click="handleClick"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "HamburgerMenuButton",
  inject: ["$device"],
  props: {
    setDrawer: Function,
    showingDrawer: Boolean,
    isLoggedIn: Boolean,
  },
  data() {
    return {
      showButton: this.isLoggedIn,
    };
  },
  watch: {
    isLoggedIn(val) {
      this.showButton = val;
    },
  },
  methods: {
    handleClick() {
      if (this.$device.isMobile) {
        this.setDrawer(true);
      } else {
        this.setDrawer(!this.showingDrawer);
      }
    },
  },
});
</script>
